import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PaginationSizeService } from '../../services/pagination-size.service';
import { FormGroup, FormControl } from '@angular/forms';
import { AppSettings } from '../../../app.settings';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'pagination-size',
    templateUrl: './pagination-size.component.html',
    styleUrls: ['./pagination-size.component.scss']
})
export class PaginationSizeFormComponent implements OnInit {
    public quantityPages = 1;
    public _page = 1;
    public length = 0;

    @Input()
    set quantityItems(value: number) {
        this.quantityPages = value;
    }

    private _quantityByPage = this.appSettings.settings.configs.defaultQuantityByPage;
    @Input()
    set quantityByPage(value: number) {
        this._quantityByPage = value;
    }
    get quantityByPage(): number {
        return this._quantityByPage;
    }

    @Input() quantityShowOnPage: number;
    @Input() group: FormGroup;
    @Input() inModal = false;

    @Output() search = new EventEmitter();

    constructor(public servicePaginationSize: PaginationSizeService,
        public appSettings: AppSettings) { }

    ngOnInit() {
        this.group.addControl('QuantidadePorPagina', new FormControl(this.appSettings.settings.configs.defaultQuantityByPage));
        this.group.get('QuantidadePorPagina').setValue(this.appSettings.settings.configs.defaultQuantityByPage);
    }

    /**
     * Método responsável por emitir o evento que define quantos items a busca deve realizar para exibir na grid.
     * @param quantity Quantidade de items que devem ser exibidos na grid.
     */
    public changeQuantityByPage(event: any) {
        const quantity = event.target.value.split(':')[1];
        if (quantity && +quantity > 0) {
            this.quantityByPage = +quantity;
            this.search.emit(+quantity);
        }
    }
}
